<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      :titulo="$t ('Aparcamientos')"
      icono="mdi-file-powerpoint-box"
      tabla="ins"
      :campos="['id_ins-', 'codins', 'nom+', 'dir-', 'codpos-', 'pob', 'pro', 'tel', 'totpla', 'codinsclo-', 'corele']"
      busqueda-rapida
      :titulo-crud="$t ('aparcamiento')"
      :permitir-anadir="permisoEscritura"
      :permitir-modificar="permisoEscritura"
      :permitir-eliminar="permisoEscritura"
      mensaje-confirmacion-al-eliminar="Al eliminar el aparcamiento, se borrarán todos los registros dependientes en Aparatos, Zonas, Cámaras y Dispositivos de interfonía.<br>¿Está seguro que desea continuar?"
    />

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";

export default {
  components: { TablaDatosAPI },
  computed: {
    permisoEscritura() {
      return this.$store.operador.atributosRol.includes ("modconins");
    }
  },
};
</script>

<style>
</style>